module.exports = __webpack_public_path__ + "img/checked_on.c2b488d0.svg";